import { nullsToUndefined } from "../../../../null.js";
export const productCardCruisesMobileConverter = (props)=>{
    const data = props.props ?? props.data ?? {};
    const { title ='' , link ={
        href: ''
    } , image ={
        src: ''
    } , price , icon ='' , icons =[] , isDeal =false , date , promo , duration , shipName , logo , isBlackfriday =false  } = data;
    const _descriptions = [
        shipName,
        duration
    ].filter((x)=>!!x);
    const _icons = icons.map(({ icon  })=>({
            icon: icon ?? ''
        }));
    return {
        ...data,
        config: {
            isBlackfriday,
            deal: isDeal,
            icon: !!icon,
            iconName: icon,
            soldOut: props.soldOut,
            literals: {
                fromCaption: price?.fromText
            }
        },
        image,
        icons: _icons,
        link,
        price: {
            value: price?.value,
            from: price?.from
        },
        title,
        subtitle: date,
        descriptions: _descriptions,
        promotion: nullsToUndefined(promo),
        company: logo
    };
};

//# sourceMappingURL=converter.js.map